import tw from 'tailwind-styled-components'

const Label = tw.label`
block 
font-semibold
text-xs
text-darkGray
truncate
pb-0.5
`

const Input = tw.input`
block 
w-full 
border
border-inputBorder
p-2
h-[38px]
text-[16px]
font-normal
outline-gray-200
rounded-lg
pl-4
`

const ButtonLocate = tw.button`
text-xs 
px-4
absolute
bg-darkGray/30
h-[38px]
w-[89.74px]
inline-flex
items-center
rounded-r-lg
right-0
text-white
hover:brightness-95
`

const ErrorText = tw.span`
text-errorText
text-xs
font-normal
absolute
w-[500px]
-bottom-[16px]
`

const InputLength = tw.span`
absolute
text-xs
-bottom-[17px]
right-0
text-darkGray/80
`

export { Label, Input, ButtonLocate, ErrorText, InputLength }
